import { render } from "./BookingForm.vue?vue&type=template&id=4b2ef099&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=4b2ef099&scoped=true&lang=css"

import exportComponent from "C:\\Ecommerce\\Furbetta\\WebAppPrenotazionePrimaVisita\\booking-prima-visita-v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2ef099"]])

export default __exports__